import { render, staticRenderFns } from "./MaleIndex.vue?vue&type=template&id=f5ebc5c4&"
import script from "./MaleIndex.vue?vue&type=script&lang=js&"
export * from "./MaleIndex.vue?vue&type=script&lang=js&"
import style0 from "./MaleIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports